export default __webpack_public_path__ + "static/blob-46-4421eaa7f543a80920f254ca6b5c335e.svg";